import { render, staticRenderFns } from "./callCenter.vue?vue&type=template&id=15c079fe&scoped=true"
import script from "./callCenter.vue?vue&type=script&lang=js"
export * from "./callCenter.vue?vue&type=script&lang=js"
import style0 from "./callCenter.vue?vue&type=style&index=0&id=15c079fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c079fe",
  null
  
)

export default component.exports